//缺1、蝴蝶
import makerjs from "makerjs";
// 矩形等去角 连线函数
function creatmyButterflyGap(area, param) {
      console.log("是否调用此函数creatOneCorner（）area=", area);
      console.log("是否调用此函数creatOneCorner（）param=", param);
      var xa = param.xa, ya = param.ya, xb = param.xb, yb = param.yb, xc = param.xc, yc = param.yc, xg = param.xg, yg = param.yg,
            xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi,
            xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf, glassH = param.glassH, glassW = param.glassW,
            x = param.x0, radius = param.r, width = param.w, height = param.h, cutLine = param.cutLine * 1, cutFilletRadius = param.cutFilletRadius * 1;
      //20250816 增加圆角 圆角半径5
      // var cutFilletRadius=r1;
      console.log("cutLine====***||||||||||||||||||===", cutLine);
      console.log("cutFilletRadius====***|||||||||||||||===", cutFilletRadius);
      /**
       if(glassW*1>glassH * 1){
            console.log("长边在X轴￥￥￥￥￥");
      
      }else{
            console.log("短边在X轴￥￥￥￥￥");
      
      }
       */


      if (glassW * 1 > glassH * 1) {
            console.log("长边在X轴￥￥￥￥￥");
            if (area == "A") {
                  var myButterflyGap = {

                        paths: {
                              "Left": new makerjs.paths.Line([xa, ya], [xa, ya - height + radius]),
                              "BottomLeft": new makerjs.paths.Arc([xa, ya - height], radius, 90, 360),
                              'Bottom': new makerjs.paths.Line([xa + radius, ya - height], [xa + width - radius, ya - height]),
                              "BottomRight": new makerjs.paths.Arc([xa + width, ya - height], radius, 180, 90),
                              "Right": new makerjs.paths.Line([xa + width, ya - height + radius], [xa + width, ya]),
                        }
                  };
                  var myButterflyGapWaterCut = {

                        paths: {
                              "EnLine": new makerjs.paths.Line([xa, ya + cutLine], [xa, ya]),
                              "Left": new makerjs.paths.Line([xa, ya], [xa, ya - height + radius]),
                              "BottomLeft": new makerjs.paths.Arc([xa, ya - height], radius, 90, 360),
                              'Bottom': new makerjs.paths.Line([xa + radius, ya - height], [xa + width - radius, ya - height]),
                              "BottomRight": new makerjs.paths.Arc([xa + width, ya - height], radius, 180, 90),
                              "Right": new makerjs.paths.Line([xa + width, ya - height + radius], [xa + width, ya]),
                              "ExLine": new makerjs.paths.Line([xa + width, ya], [xa + width, ya + cutLine]),
                        }
                  };
            } else if (area == "B") {
                  var myButterflyGap = {
                        paths: {
                              "Left": new makerjs.paths.Line([xb, yb], [xb, yb - height + radius]),
                              "BottomLeft": new makerjs.paths.Arc([xb, yb - height], radius, 90, 360),
                              'Bottom': new makerjs.paths.Line([xb + radius, yb - height], [xb + width - radius, yb - height]),
                              "BottomRight": new makerjs.paths.Arc([xb + width, yb - height], radius, 180, 90),
                              "Right": new makerjs.paths.Line([xb + width, yb - height + radius], [xb + width, yb]),
                        }
                  };
                  var myButterflyGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xb, yb + cutLine], [xb, yb]),
                              "Left": new makerjs.paths.Line([xb, yb], [xb, yb - height + radius]),
                              "BottomLeft": new makerjs.paths.Arc([xb, yb - height], radius, 90, 360),
                              'Bottom': new makerjs.paths.Line([xb + radius, yb - height], [xb + width - radius, yb - height]),
                              "BottomRight": new makerjs.paths.Arc([xb + width, yb - height], radius, 180, 90),
                              "Right": new makerjs.paths.Line([xb + width, yb - height + radius], [xb + width, yb]),
                              "ExLine": new makerjs.paths.Line([xb + width, yb], [xb + width, yb + cutLine]),
                        }
                  };
            } else if (area == "C") {
                  var myButterflyGap = {
                        paths: {
                              "Left": new makerjs.paths.Line([xc - width, yc], [xc - width, yc - height + radius]),
                              "BottomLeft": new makerjs.paths.Arc([xc - width, yc - height], radius, 90, 360),
                              'Bottom': new makerjs.paths.Line([xc - width + radius, yc - height], [xc - radius, yc - height]),
                              "BottomRight": new makerjs.paths.Arc([xc, yc - height], radius, 180, 90),
                              "Right": new makerjs.paths.Line([xc, yc - height + radius], [xc, yc]),
                        }
                  };
                  var myButterflyGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xc - width, yc + cutLine], [xc - width, yc]),
                              "Left": new makerjs.paths.Line([xc - width, yc], [xc - width, yc - height + radius]),
                              "BottomLeft": new makerjs.paths.Arc([xc - width, yc - height], radius, 90, 360),
                              'Bottom': new makerjs.paths.Line([xc - width + radius, yc - height], [xc - radius, yc - height]),
                              "BottomRight": new makerjs.paths.Arc([xc, yc - height], radius, 180, 90),
                              "Right": new makerjs.paths.Line([xc, yc - height + radius], [xc, yc]),
                              "ExLine": new makerjs.paths.Line([xc, yc], [xc, yc + cutLine]),
                        }
                  };
            } else if (area == "G") {
                  var myButterflyGap = {
                        paths: {
                              "Left": new makerjs.paths.Line([xg, yg], [xg, yg + height - radius]),
                              "TopLeft": new makerjs.paths.Arc([xg, yg + height - radius], [xg + radius, yg + height], radius, true, true),
                              'Top': new makerjs.paths.Line([xg + radius, yg + height], [xg + width - radius, yg + height]),
                              "TopRight": new makerjs.paths.Arc([xg + width - radius, yg + height], [xg + width, yg + height - radius], radius, true, true),
                              "Right": new makerjs.paths.Line([xg + width, yg + height - radius], [xg + width, yg]),
                        }
                  };
                  var myButterflyGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xg, yg - cutLine], [xg, yg]),
                              "Left": new makerjs.paths.Line([xg, yg], [xg, yg + height - radius]),
                              "BottomLeft": new makerjs.paths.Arc([xg, yg + height - radius], [xg + radius, yg + height], radius, true, true),
                              'Bottom': new makerjs.paths.Line([xg + radius, yg + height], [xg + width - radius, yg + height]),
                              "BottomRight": new makerjs.paths.Arc([xg + width - radius, yg + height], [xg + width, yg + height - radius], radius, true, true),
                              "Right": new makerjs.paths.Line([xg + width, yg + height - radius], [xg + width, yg]),
                              "ExLine": new makerjs.paths.Line([xg + width, yg], [xg + width, yg - cutLine]),
                        }
                  };
            } else if (area == "H") {
                  var myButterflyGap = {
                        paths: {
                              "Left": new makerjs.paths.Line([xh, yh], [xh, yh + height - radius]),
                              "TopLeft": new makerjs.paths.Arc([xh, yh + height - radius], [xh + radius, yh + height], radius, true, true),
                              'Top': new makerjs.paths.Line([xh + radius, yh + height], [xh + width - radius, yh + height]),
                              "TopRight": new makerjs.paths.Arc([xh + width - radius, yh + height], [xh + width, yh + height - radius], radius, true, true),
                              "Right": new makerjs.paths.Line([xh + width, yh + height - radius], [xh + width, yh]),
                        }
                  };
                  var myButterflyGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xh, yh - cutLine], [xh, yh]),
                              "Left": new makerjs.paths.Line([xh, yh], [xh, yh + height - radius]),
                              "BottomLeft": new makerjs.paths.Arc([xh, yh + height - radius], [xh + radius, yh + height], radius, true, true),
                              'Bottom': new makerjs.paths.Line([xh + radius, yh + height], [xh + width - radius, yh + height]),
                              "BottomRight": new makerjs.paths.Arc([xh + width - radius, yh + height], [xh + width, yh + height - radius], radius, true, true),
                              "Right": new makerjs.paths.Line([xh + width, yh + height - radius], [xh + width, yh]),
                              "ExLine": new makerjs.paths.Line([xh + width, yh], [xh + width, yh - cutLine]),
                        }
                  };
            } else if (area == "I") {
                  var myButterflyGap = {
                        paths: {
                              "Left": new makerjs.paths.Line([xi - width, yi], [xi - width, yi + height - radius]),
                              "TopLeft": new makerjs.paths.Arc([xi - width, yi + height - radius], [xi - width + radius, yi + height], radius, true, true),
                              'Top': new makerjs.paths.Line([xi - width + radius, yi + height], [xi - radius, yi + height]),
                              "TopRight": new makerjs.paths.Arc([xi - radius, yi + height], [xi, yi + height - radius], radius, true, true),
                              "Right": new makerjs.paths.Line([xi, yi + height - radius], [xi, yi]),
                        }
                  };
                  var myButterflyGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xi - width, yi - cutLine], [xi - width, yi]),
                              "Left": new makerjs.paths.Line([xi - width, yi], [xi - width, yi + height - radius]),
                              "BottomLeft": new makerjs.paths.Arc([xi - width, yi + height - radius], [xi - width + radius, yi + height], radius, true, true),
                              'Bottom': new makerjs.paths.Line([xi - width + radius, yi + height], [xi - radius, yi + height]),
                              "BottomRight": new makerjs.paths.Arc([xi - radius, yi + height], [xi, yi + height - radius], radius, true, true),
                              "Right": new makerjs.paths.Line([xi, yi + height - radius], [xi, yi]),
                              "ExLine": new makerjs.paths.Line([xi, yi], [xi, yi - cutLine]),
                        }
                  };
            }
      } else {
            console.log("短边在X轴￥￥￥￥￥");
            if (area == "A") {
                  var myButterflyGap = {
                        paths: {
                              "Left": new makerjs.paths.Line([xa, ya], [xa + height - radius, ya]),
                              "BottomLeft": new makerjs.paths.Arc([xa + height - radius, ya], [xa + height, ya - radius], radius, true, true),
                              'Bottom': new makerjs.paths.Line([xa + height, ya - radius], [xa + height, ya - width + radius]),
                              "BottomRight": new makerjs.paths.Arc([xa + height, ya - width + radius], [xa + height - radius, ya - width], radius, true, true),
                              "Right": new makerjs.paths.Line([xa + height - radius, ya - width], [xa, ya - width]),
                        }
                  };
                  var myButterflyGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xa - cutLine, ya], [xa, ya]),
                              "Left": new makerjs.paths.Line([xa, ya], [xa + height - radius, ya]),
                              "BottomLeft": new makerjs.paths.Arc([xa + height - radius, ya], [xa + height, ya - radius], radius, true, true),
                              'Bottom': new makerjs.paths.Line([xa + height, ya - radius], [xa + height, ya - width + radius]),
                              "BottomRight": new makerjs.paths.Arc([xa + height, ya - width + radius], [xa + height - radius, ya - width], radius, true, true),
                              "Right": new makerjs.paths.Line([xa + height - radius, ya - width], [xa, ya - width]),
                              "ExLine": new makerjs.paths.Line([xa, ya - width], [xa - cutLine, ya - width]),
                        }
                  };
            } else if (area == "D") {
                  var myButterflyGap = {
                        paths: {
                              "Left": new makerjs.paths.Line([xd, yd + width / 2], [xd + height - radius, yd + width / 2]),
                              "BottomLeft": new makerjs.paths.Arc([xd + height - radius, yd + width / 2], [xd + height, yd - radius + width / 2], radius, true, true),
                              'Bottom': new makerjs.paths.Line([xd + height, yd - radius + width / 2], [xd + height, yd - width / 2 + radius]),
                              "BottomRight": new makerjs.paths.Arc([xd + height, yd - width / 2 + radius], [xd + height - radius, yd - width / 2], radius, true, true),
                              "Right": new makerjs.paths.Line([xd + height - radius, yd - width / 2], [xd, yd - width / 2]),
                        }
                  };
                  var myButterflyGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xd - cutLine, yd + width / 2], [xd, yd + width / 2]),
                              "Left": new makerjs.paths.Line([xd, yd + width / 2], [xd + height - radius, yd + width / 2]),
                              "BottomLeft": new makerjs.paths.Arc([xd + height - radius, yd + width / 2], [xd + height, yd - radius + width / 2], radius, true, true),
                              'Bottom': new makerjs.paths.Line([xd + height, yd - radius + width / 2], [xd + height, yd - width / 2 + radius]),
                              "BottomRight": new makerjs.paths.Arc([xd + height, yd - width / 2 + radius], [xd + height - radius, yd - width / 2], radius, true, true),
                              "Right": new makerjs.paths.Line([xd + height - radius, yd - width / 2], [xd, yd - width / 2]),
                              "ExLine": new makerjs.paths.Line([xd, yd - width / 2], [xd - cutLine, yd - width / 2]),
                        }
                  };
            } else if (area == "G") {
                  var myButterflyGap = {
                        paths: {
                              "Left": new makerjs.paths.Line([xg, yg], [xg + height - radius, yg]),
                              "BottomLeft": new makerjs.paths.Arc([xg + height - radius, yg], [xg + height, yg + radius], radius, true, false),
                              'Bottom': new makerjs.paths.Line([xg + height, yg + radius], [xg + height, yg + width - radius]),
                              "BottomRight": new makerjs.paths.Arc([xg + height, yg + width - radius], [xg + height - radius, yg + width], radius, true, false),
                              "Right": new makerjs.paths.Line([xg + height - radius, yg + width], [xg, yg + width]),
                        }
                  };
                  var myButterflyGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xg - cutLine, yg], [xg, yg]),
                              "Left": new makerjs.paths.Line([xg, yg], [xg + height - radius, yg]),
                              "BottomLeft": new makerjs.paths.Arc([xg + height - radius, yg], [xg + height, yg + radius], radius, true, false),
                              'Bottom': new makerjs.paths.Line([xg + height, yg + radius], [xg + height, yg + width - radius]),
                              "BottomRight": new makerjs.paths.Arc([xg + height, yg + width - radius], [xg + height - radius, yg + width], radius, true, false),
                              "Right": new makerjs.paths.Line([xg + height - radius, yg + width], [xg, yg + width]),
                              "ExLine": new makerjs.paths.Line([xg, yg + width], [xg - cutLine, yg + width]),
                        }
                  };
            } else if (area == "C") {
                  var myButterflyGap = {
                        paths: {
                              "Left": new makerjs.paths.Line([xc, yc], [xc - height + radius, yc]),
                              "BottomLeft": new makerjs.paths.Arc([xc - height + radius, yc], [xc - height, yc - radius], radius, true, false),
                              'Bottom': new makerjs.paths.Line([xc - height, yc - radius], [xc - height, yc - width + radius]),
                              "BottomRight": new makerjs.paths.Arc([xc - height, yc - width + radius], [xc - height + radius, yc - width], radius, true, false),
                              "Right": new makerjs.paths.Line([xc - height + radius, yc - width], [xc, yc - width]),
                        }
                  };
                  var myButterflyGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xc + cutLine, yc], [xc, yc]),
                              "Left": new makerjs.paths.Line([xc, yc], [xc - height + radius, yc]),
                              "BottomLeft": new makerjs.paths.Arc([xc - height + radius, yc], [xc - height, yc - radius], radius, true, false),
                              'Bottom': new makerjs.paths.Line([xc - height, yc - radius], [xc - height, yc - width + radius]),
                              "BottomRight": new makerjs.paths.Arc([xc - height, yc - width + radius], [xc - height + radius, yc - width], radius, true, false),
                              "Right": new makerjs.paths.Line([xc - height + radius, yc - width], [xc, yc - width]),
                              "ExLine": new makerjs.paths.Line([xc, yc - width], [xc + cutLine, yc - width]),
                        }
                  };
            } else if (area == "F") {
                  var myButterflyGap = {
                        paths: {
                              "Left": new makerjs.paths.Line([xf, yf + width / 2], [xf - height + radius, yf + width / 2]),
                              "BottomLeft": new makerjs.paths.Arc([xf - height + radius, yf + width / 2], [xf - height, yf - radius + width / 2], radius, true, false),
                              'Bottom': new makerjs.paths.Line([xf - height, yf - radius + width / 2], [xf - height, yf - width / 2 + radius]),
                              "BottomRight": new makerjs.paths.Arc([xf - height, yf - width / 2 + radius], [xf - height + radius, yf - width / 2], radius, true, false),
                              "Right": new makerjs.paths.Line([xf - height + radius, yf - width / 2], [xf, yf - width / 2]),
                        }
                  };
                  var myButterflyGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xf + cutLine, yf + width / 2], [xf, yf + width / 2]),
                              "Left": new makerjs.paths.Line([xf, yf + width / 2], [xf - height + radius, yf + width / 2]),
                              "BottomLeft": new makerjs.paths.Arc([xf - height + radius, yf + width / 2], [xf - height, yf - radius + width / 2], radius, true, false),
                              'Bottom': new makerjs.paths.Line([xf - height, yf - radius + width / 2], [xf - height, yf - width / 2 + radius]),
                              "BottomRight": new makerjs.paths.Arc([xf - height, yf - width / 2 + radius], [xf - height + radius, yf - width / 2], radius, true, false),
                              "Right": new makerjs.paths.Line([xf - height + radius, yf - width / 2], [xf, yf - width / 2]),
                              "ExLine": new makerjs.paths.Line([xf, yf - width / 2], [xf + cutLine, yf - width / 2]),
                        }
                  };
            } else if (area == "I") {
                  var myButterflyGap = {
                        paths: {
                              "Left": new makerjs.paths.Line([xi, yi], [xi - height + radius, yi]),
                              "BottomLeft": new makerjs.paths.Arc([xi - height + radius, yi], [xi - height, yi + radius], radius, true, true),
                              'Bottom': new makerjs.paths.Line([xi - height, yi + radius], [xi - height, yi + width - radius]),
                              "BottomRight": new makerjs.paths.Arc([xi - height, yi + width - radius], [xi - height + radius, yi + width], radius, true, true),
                              "Right": new makerjs.paths.Line([xi - height + radius, yi + width], [xi, yi + width]),
                        }
                  };
                  var myButterflyGapWaterCut = {
                        paths: {
                              "EnLine": new makerjs.paths.Line([xi + cutLine, yi], [xi, yi]),
                              "Left": new makerjs.paths.Line([xi, yi], [xi - height + radius, yi]),
                              "BottomLeft": new makerjs.paths.Arc([xi - height + radius, yi], [xi - height, yi + radius], radius, true, true),
                              'Bottom': new makerjs.paths.Line([xi - height, yi + radius], [xi - height, yi + width - radius]),
                              "BottomRight": new makerjs.paths.Arc([xi - height, yi + width - radius], [xi - height + radius, yi + width], radius, true, true),
                              "Right": new makerjs.paths.Line([xi - height + radius, yi + width], [xi, yi + width]),
                              "ExLine": new makerjs.paths.Line([xi, yi + width], [xi + cutLine, yi + width]),
                        }
                  };
            }
      }
      var fillet1 = makerjs.path.fillet(myButterflyGap.paths.Left, myButterflyGap.paths.BottomLeft, cutFilletRadius);
      var fillet2 = makerjs.path.fillet(myButterflyGap.paths.BottomLeft, myButterflyGap.paths.Bottom, cutFilletRadius);
      var fillet3 = makerjs.path.fillet(myButterflyGap.paths.Bottom, myButterflyGap.paths.BottomRight, cutFilletRadius);
      var fillet4 = makerjs.path.fillet(myButterflyGap.paths.BottomRight, myButterflyGap.paths.Right, cutFilletRadius);
      myButterflyGap.paths.fillet1 = fillet1;
      myButterflyGap.paths.fillet2 = fillet2;
      myButterflyGap.paths.fillet3 = fillet3;
      myButterflyGap.paths.fillet4 = fillet4;
      var fillet11 = makerjs.path.fillet(myButterflyGapWaterCut.paths.Left, myButterflyGapWaterCut.paths.BottomLeft, cutFilletRadius);
      var fillet22 = makerjs.path.fillet(myButterflyGapWaterCut.paths.BottomLeft, myButterflyGapWaterCut.paths.Bottom, cutFilletRadius);
      var fillet33 = makerjs.path.fillet(myButterflyGapWaterCut.paths.Bottom, myButterflyGapWaterCut.paths.BottomRight, cutFilletRadius);
      var fillet44 = makerjs.path.fillet(myButterflyGapWaterCut.paths.BottomRight, myButterflyGapWaterCut.paths.Right, cutFilletRadius);
      myButterflyGapWaterCut.paths.fillet11 = fillet11;
      myButterflyGapWaterCut.paths.fillet22 = fillet22;
      myButterflyGapWaterCut.paths.fillet33 = fillet33;
      myButterflyGapWaterCut.paths.fillet44 = fillet44;
      return [myButterflyGap, myButterflyGapWaterCut];
};
// 矩形等去角标记 连线函数      
function creatmyButterflyGapMark(outParam, area, param, inputParam, fixedParam, OffsetParam, zoom) {
      console.log("creatmyButterflyGapMark==", area);
      console.log("creatmyButterflyGapMark==param", param);
      console.log("creatmyButterflyGapMark==outParam", outParam);
      console.log("creatmyButterflyGapMark==inputParam", inputParam);
      console.log("creatmyButterflyGapMark===OffsetParam", OffsetParam);
      console.log("creatmyButterflyGapMark===fixedParam", fixedParam);
      var HH = outParam.H, WW = outParam.W, R = inputParam.R, W = inputParam.W, H = inputParam.H, X = inputParam.X, Y = inputParam.Y, myZoom = zoom * 1,
            glassW = outParam.glassW, glassH = outParam.glassH,
            xa = param.xa, ya = param.ya, xb = param.xb, yb = param.yb, xc = param.xc, yc = param.yc, xg = param.xg, yg = param.yg,
            xh = param.xh, yh = param.yh, xi = param.xi, yi = param.yi, xd = param.xd, yd = param.yd, xf = param.xf, yf = param.yf,
            x = param.x0, radius = param.r, width = param.w, height = param.h,
            markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
            markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,
            h = H * 1 * myZoom,
            w = W * 1 * myZoom,
            d = R * 2 * myZoom,
            r = d / 2,
            dd = (d / 2) / Math.sqrt(2),
            x0 = X * 1 * myZoom,
            y0 = Y * 1 * myZoom;
      if (d !== 0) {
            var TxtD = "R" + R;
      }
      if (h !== 0) {
            var TxtH = H;
      }
      if (w !== 0) {
            var TxtW = W;
      }
      if (x0 !== 0) {
            var TxtX = X;
      }
      if (y0 !== 0) {
            var TxtY = Y;
      }
      if (glassW * 1 > glassH * 1) {
            console.log("长边在X轴￥￥￥￥￥");
            if (area == "A") {
                  var myBfgGapAMakerW = {
                        paths: {
                              "WALine0": new makerjs.paths.Line([xa, ya - markShiftTwo], [xa + w, ya - markShiftTwo]),
                        }
                  };
                  var myBfgGapAMakerH = {
                        paths: {
                              "HALine0": new makerjs.paths.Line([xa - markShift, ya], [xa - markShift, ya - h]),
                              "HALine2": new makerjs.paths.Line([xa - markShiftFour, ya - h], [xa, ya - h]),
                        }
                  };
                  var myBfgGapAMakerX = {
                        paths: {
                              "XALine0": new makerjs.paths.Line([xa - x0, ya + markShift], [xa, ya + markShift]),
                              "XALine1": new makerjs.paths.Line([xa - x0, ya], [xa - x0, ya + markShiftFour]),
                              "XALine2": new makerjs.paths.Line([xa, ya], [xa, ya + markShiftFour]),
                        }
                  };
                  var myBfgGapAMakerD = {
                        paths: {
                              "DALine0": new makerjs.paths.Line([xa + w, ya - h], [xa + w + dd + markHolesOneD, ya - h - dd - markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapAMakerW, TxtW, [xa, ya - markShiftFour], [xa + w, ya - markShiftFour]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapAMakerH, TxtH, [xa - markShiftThree, ya - h], [xa - markShiftThree, ya]);//H文字标注
                  makerjs.model.addCaption(myBfgGapAMakerX, TxtX, [xa - x0, ya + markShiftTwo], [xa, ya + markShiftTwo]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapAMakerD, TxtD, [xa + w + markShift, ya - h], [xa + w + markShift + dd + markHolesOneD, ya - h - dd - markHolesOneD]);//D文字标注  
                  var markers = [myBfgGapAMakerW, myBfgGapAMakerH, myBfgGapAMakerX, myBfgGapAMakerD]
            } else if (area == "B") {
                  var myBfgGapBMakerW = {
                        paths: {
                              "WBLine0": new makerjs.paths.Line([xb, yb - markShiftTwo], [xb + w, yb - markShiftTwo]),
                        }
                  };
                  var myBfgGapBMakerH = {
                        paths: {
                              "HBLine0": new makerjs.paths.Line([xb - markShift, yb], [xb - markShift, yb - h]),
                              "HBLine2": new makerjs.paths.Line([xb - markShiftFour, yb - h], [xb, yb - h]),
                        }
                  };
                  var myBfgGapBMakerX = {
                        paths: {
                              // "XBLine0": new makerjs.paths.Line([xb-x0, yb + markShift], [xb, yb + markShift]),
                              // "XBLine1": new makerjs.paths.Line([xb-x0, yb], [xb-x0, yb+markShiftFour]),
                              // "XBLine2": new makerjs.paths.Line([xb, yb], [xb, yb+markShiftFour]),
                        }
                  };
                  var myBfgGapBMakerD = {
                        paths: {
                              "DBLine0": new makerjs.paths.Line([xb + w, yb - h], [xb + w + dd + markHolesOneD, yb - h - dd - markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapBMakerW, TxtW, [xb, yb - markShiftFour], [xb + w, yb - markShiftFour]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapBMakerH, TxtH, [xb - markShiftThree, yb - h], [xb - markShiftThree, yb]);//H文字标注
                  makerjs.model.addCaption(myBfgGapBMakerX, TxtX, [xb - x0, yb + markShiftTwo], [xa, yb + markShiftTwo]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapBMakerD, TxtD, [xb + w + markShift, yb - h], [xb + w + markShift + dd + markHolesOneD, yb - h - dd - markHolesOneD]);//D文字标注  
                  var markers = [myBfgGapBMakerW, myBfgGapBMakerH, myBfgGapBMakerX, myBfgGapBMakerD]
            } else if (area == "C") {
                  var myBfgGapCMakerW = {
                        paths: {
                              "WCLine0": new makerjs.paths.Line([xc - w, yc - markShiftTwo], [xc, yc - markShiftTwo]),
                        }
                  };
                  var myBfgGapCMakerH = {
                        paths: {
                              "HCLine0": new makerjs.paths.Line([xc - w - markShift, yc], [xc - w - markShift, yc - h]),
                              "HCLine2": new makerjs.paths.Line([xc - w - markShiftFour, yc - h], [xc - w, yc - h]),
                        }
                  };
                  var myBfgGapCMakerX = {
                        paths: {
                              "XCLine0": new makerjs.paths.Line([xc, yc + markShift], [xc + x0, yc + markShift]),
                              "XCLine1": new makerjs.paths.Line([xc + x0, yc], [xc + x0, yc + markShiftFour]),
                              "XCLine2": new makerjs.paths.Line([xc, yc], [xc, yc + markShiftFour]),
                        }
                  };
                  var myBfgGapCMakerD = {
                        paths: {
                              "DCLine0": new makerjs.paths.Line([xc, yc - h], [xc + dd + markHolesOneD, yc - h - dd - markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapCMakerW, TxtW, [xc - w, yc - markShiftFour], [xc, yc - markShiftFour]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapCMakerH, TxtH, [xc - w - markShiftThree, yc - h], [xc - w - markShiftThree, yc]);//H文字标注
                  makerjs.model.addCaption(myBfgGapCMakerX, TxtX, [xc, yc + markShiftTwo], [xc + x0, yc + markShiftTwo]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapCMakerD, TxtD, [xc + markShift, yc - h], [xc + markShift + dd + markHolesOneD, yc - h - dd - markHolesOneD]);//D文字标注  
                  var markers = [myBfgGapCMakerW, myBfgGapCMakerH, myBfgGapCMakerX, myBfgGapCMakerD]
            } else if (area == "G") {
                  var myBfgGapGMakerW = {
                        paths: {
                              "WGLine0": new makerjs.paths.Line([xg, yg + markShiftTwo], [xg + w, yg + markShiftTwo]),
                        }
                  };
                  var myBfgGapGMakerH = {
                        paths: {
                              "HGLine0": new makerjs.paths.Line([xg - markShift, yg], [xg - markShift, yg + h]),
                              "HGLine2": new makerjs.paths.Line([xg - markShiftFour, yg + h], [xg, yg + h]),
                        }
                  };
                  var myBfgGapGMakerX = {
                        paths: {
                              "XGLine0": new makerjs.paths.Line([xg - x0, yg - markShiftTwo], [xg, yg - markShiftTwo]),
                              "XGLine1": new makerjs.paths.Line([xg - x0, yg], [xg - x0, yg - markShiftFour]),
                              "XGLine2": new makerjs.paths.Line([xg, yg], [xg, yg - markShiftFour]),
                        }
                  };
                  var myBfgGapGMakerD = {
                        paths: {
                              "DGLine0": new makerjs.paths.Line([xg + w, yg + h], [xg + w + dd + markHolesOneD, yg + h - dd - markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapGMakerW, TxtW, [xg, yg + markShiftFour], [xg + w, yg + markShiftFour]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapGMakerH, TxtH, [xg - markShiftThree, yg], [xg - markShiftThree, yg + h]);//H文字标注
                  makerjs.model.addCaption(myBfgGapGMakerX, TxtX, [xg - x0, yg - markShiftFour], [xg, yg - markShiftFour]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapGMakerD, TxtD, [xg + w + markShift, yg + h], [xg + w + markShift + dd + markHolesOneD, yg + h - dd - markHolesOneD]);//D文字标注  
                  var markers = [myBfgGapGMakerW, myBfgGapGMakerH, myBfgGapGMakerX, myBfgGapGMakerD]
            } else if (area == "H") {
                  var myBfgGapHMakerW = {
                        paths: {
                              "WHLine0": new makerjs.paths.Line([xh, yh + markShiftTwo], [xh + w, yh + markShiftTwo]),
                        }
                  };
                  var myBfgGapHMakerH = {
                        paths: {
                              "HHLine0": new makerjs.paths.Line([xh - markShift, yh], [xh - markShift, yh + h]),
                              "HHLine2": new makerjs.paths.Line([xh - markShiftFour, yh + h], [xh, yh + h]),
                        }
                  };
                  var myBfgGapHMakerX = {
                        paths: {
                              // "XHLine0": new makerjs.paths.Line([xh-x0, yh - markShiftTwo], [xh, yh - markShiftTwo]),
                              // "XHLine1": new makerjs.paths.Line([xh-x0, yh], [xh-x0, yh-markShiftFour]),
                              // "XHLine2": new makerjs.paths.Line([xh, yh], [xh, yh-markShiftFour]),
                        }
                  };
                  var myBfgGapHMakerD = {
                        paths: {
                              "DHLine0": new makerjs.paths.Line([xh + w, yh + h], [xh + w + dd + markHolesOneD, yh + h - dd - markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapHMakerW, TxtW, [xh, yh + markShiftFour], [xh + w, yh + markShiftFour]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapHMakerH, TxtH, [xh - markShiftThree, yh], [xh - markShiftThree, yh + h]);//H文字标注
                  makerjs.model.addCaption(myBfgGapHMakerX, TxtX, [xh - x0, yh - markShiftFour], [xh, yh - markShiftFour]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapHMakerD, TxtD, [xh + w + markShift, yh + h], [xh + w + markShift + dd + markHolesOneD, yh + h - dd - markHolesOneD]);//D文字标注  
                  var markers = [myBfgGapHMakerW, myBfgGapHMakerH, myBfgGapHMakerX, myBfgGapHMakerD]
            } else if (area == "I") {
                  var myBfgGapIMakerW = {
                        paths: {
                              "WILine0": new makerjs.paths.Line([xi - w, yi + markShiftTwo], [xi, yi + markShiftTwo]),
                        }
                  };
                  var myBfgGapIMakerH = {
                        paths: {
                              "HILine0": new makerjs.paths.Line([xi - w - markShift, yi], [xi - w - markShift, yi + h]),
                              "HILine2": new makerjs.paths.Line([xi - w - markShiftFour, yi + h], [xi - w, yi + h]),
                        }
                  };
                  var myBfgGapIMakerX = {
                        paths: {
                              "XILine0": new makerjs.paths.Line([xi, yi - markShiftTwo], [xi + x0, yi - markShiftTwo]),
                              "XILine1": new makerjs.paths.Line([xi + x0, yi], [xi + x0, yi - markShiftFour]),
                              "XILine2": new makerjs.paths.Line([xi, yi], [xi, yi - markShiftFour]),
                        }
                  };
                  var myBfgGapIMakerD = {
                        paths: {
                              "DILine0": new makerjs.paths.Line([xi, yi + h], [xi + dd + markHolesOneD, yi + h - dd - markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapIMakerW, TxtW, [xi - w, yi + markShiftFour], [xi, yi + markShiftFour]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapIMakerH, TxtH, [xi - w - markShiftThree, yi], [xi - w - markShiftThree, yi + h]);//H文字标注
                  makerjs.model.addCaption(myBfgGapIMakerX, TxtX, [xi, yi - markShiftFour], [xi + x0, yi - markShiftFour]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapIMakerD, TxtD, [xi + markShift, yi + h], [xi + markShift + dd + markHolesOneD, yi + h - dd - markHolesOneD]);//D文字标注  
                  var markers = [myBfgGapIMakerW, myBfgGapIMakerH, myBfgGapIMakerX, myBfgGapIMakerD]
            }
      } else {
            console.log("短边在X轴￥￥￥￥￥");
            if (area == "A") {
                  var myBfgGapAMakerW = {
                        paths: {
                              "WALine0": new makerjs.paths.Line([xa + markShiftTwo, ya - w], [xa + markShiftTwo, ya]),
                        }
                  };
                  var myBfgGapAMakerH = {
                        paths: {
                              "HALine0": new makerjs.paths.Line([xa, ya + markShift], [xa + h, ya + markShift]),
                              "HALine2": new makerjs.paths.Line([xa + h, ya], [xa + h, ya + markShiftFour]),
                        }
                  };
                  var myBfgGapAMakerY = {
                        paths: {
                              "YALine0": new makerjs.paths.Line([xa - markShiftTwo, ya], [xa - markShiftTwo, ya + y0]),
                              "YALine1": new makerjs.paths.Line([xa - markShiftFour, ya + y0], [xa, ya + y0]),
                              "YALine2": new makerjs.paths.Line([xa - markShiftFour, ya], [xa, ya]),
                        }
                  };
                  var myBfgGapAMakerD = {
                        paths: {
                              "DALine0": new makerjs.paths.Line([xa + h, ya - w], [xa + h + dd + markHolesOneD, ya - w - dd - markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapAMakerW, TxtW, [xa + markShiftFour, ya - w], [xa + markShiftFour, ya]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapAMakerH, TxtH, [xa, ya + markShiftThree], [xa + h, ya + markShiftThree]);//H文字标注
                  makerjs.model.addCaption(myBfgGapAMakerY, TxtY, [xa - markShiftFour, ya], [xa - markShiftFour, ya + y0]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapAMakerD, TxtD, [xa + h + markShift, ya - w], [xa + h + markShift + dd + markHolesOneD, ya - w - dd - markHolesOneD]);//D文字标注  
                  var markers = [myBfgGapAMakerW, myBfgGapAMakerH, myBfgGapAMakerY, myBfgGapAMakerD]
            } else if (area == "D") {
                  var myBfgGapDMakerW = {
                        paths: {
                              "WBLine0": new makerjs.paths.Line([xd + markShift, yd - w / 2], [xd + markShift, yd + w / 2]),
                        }
                  };
                  var myBfgGapDMakerH = {
                        paths: {
                              "HBLine0": new makerjs.paths.Line([xd, yd + markShift + w / 2], [xd + h, yd + markShift + w / 2]),
                              "HBLine2": new makerjs.paths.Line([xd + h, yd + w / 2], [xd + h, yd + markShiftFour + w / 2]),
                        }
                  };
                  var myBfgGapDMakerY = {
                        paths: {
                              // "YBLine0": new makerjs.paths.Line([xb-x0, yb + markShift], [xb, yb + markShift]),
                              // "YBLine1": new makerjs.paths.Line([xb-x0, yb], [xb-x0, yb+markShiftFour]),
                              // "YBLine2": new makerjs.paths.Line([xb, yb], [xb, yb+markShiftFour]),
                        }
                  };
                  var myBfgGapDMakerD = {
                        paths: {
                              "DBLine0": new makerjs.paths.Line([xd + h, yd - w / 2], [xd + h + dd + markHolesOneD, yd - w / 2 - dd - markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapDMakerW, TxtW, [xd + markShiftThree, yd - w / 2], [xd + markShiftThree, yd + w / 2]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapDMakerH, TxtH, [xd, yd + markShiftThree + w / 2], [xd + h, yd + markShiftThree + w / 2]);//H文字标注
                  makerjs.model.addCaption(myBfgGapDMakerY, TxtY, [xd - markShiftFour, yd + w / 2], [xd - markShiftFour, yd + y0 + w / 2]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapDMakerD, TxtD, [xd + h + markShift, yd - w / 2], [xd + h + markShift + dd + markHolesOneD, yd - w / 2 - dd - markHolesOneD]);//D文字标注  
                  var markers = [myBfgGapDMakerW, myBfgGapDMakerH, myBfgGapDMakerY, myBfgGapDMakerD]
            } else if (area == "C") {
                  var myBfgGapCMakerW = {
                        paths: {
                              "WCLine0": new makerjs.paths.Line([xc - markShift, yc - w], [xc - markShift, yc]),
                        }
                  };
                  var myBfgGapCMakerH = {
                        paths: {
                              "HCLine0": new makerjs.paths.Line([xc - h, yc + markShift], [xc, yc + markShift]),
                              "HCLine2": new makerjs.paths.Line([xc - h, yc], [xc - h, yc + markShiftFour]),
                        }
                  };
                  var myBfgGapCMakerY = {
                        paths: {
                              "YCLine0": new makerjs.paths.Line([xc + markShift, yc], [xc + markShift, yc + y0]),
                              "YCLine1": new makerjs.paths.Line([xc, yc + y0], [xc + markShiftFour, yc + y0]),
                              "YCLine2": new makerjs.paths.Line([xc, yc], [xc + markShiftFour, yc]),
                        }
                  };
                  var myBfgGapCMakerD = {
                        paths: {
                              "DCLine0": new makerjs.paths.Line([xc - h, yc], [xc - h - dd - markHolesOneD, yc + dd + markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapCMakerW, TxtW, [xc - markShiftTwo, yc - w], [xc - markShiftTwo, yc]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapCMakerH, TxtH, [xc - h, yc + markShiftThree], [xc, yc + markShiftThree]);//H文字标注
                  makerjs.model.addCaption(myBfgGapCMakerY, TxtY, [xc + markShiftFour, yc], [xc + markShiftFour, yc + y0]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapCMakerD, TxtD, [xc - h - dd - markHolesOneD, yc + markShift + dd + markHolesOneD], [xc - h, yc + markShift]);//D文字标注  
                  var markers = [myBfgGapCMakerW, myBfgGapCMakerH, myBfgGapCMakerY, myBfgGapCMakerD]
            } else if (area == "G") {
                  var myBfgGapGMakerW = {
                        paths: {
                              "WGLine0": new makerjs.paths.Line([xg + markShiftTwo, yg + w], [xg + markShiftTwo, yg]),
                        }
                  };
                  var myBfgGapGMakerH = {
                        paths: {
                              "HGLine0": new makerjs.paths.Line([xg, yg - markShift], [xg + h, yg - markShift]),
                              "HGLine2": new makerjs.paths.Line([xg + h, yg], [xg + h, yg - markShiftFour]),
                        }
                  };
                  var myBfgGapGMakerY = {
                        paths: {
                              "YGLine0": new makerjs.paths.Line([xg - markShiftTwo, yg], [xg - markShiftTwo, yg - y0]),
                              "YGLine1": new makerjs.paths.Line([xg - markShiftFour, yg - y0], [xg, yg - y0]),
                              "YGLine2": new makerjs.paths.Line([xg - markShiftFour, yg], [xg, yg]),
                        }
                  };
                  var myBfgGapGMakerD = {
                        paths: {
                              "DGLine0": new makerjs.paths.Line([xg + h, yg + w], [xg + h + dd + markHolesOneD, yg + w + dd + markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapGMakerW, TxtW, [xg + markShiftFour, yg + w], [xg + markShiftFour, yg]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapGMakerH, TxtH, [xg, yg - markShiftThree], [xg + h, yg - markShiftThree]);//H文字标注
                  makerjs.model.addCaption(myBfgGapGMakerY, TxtY, [xg - markShiftFour, yg], [xg - markShiftFour, yg - y0]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapGMakerD, TxtD, [xg + h, yg + w + markShift], [xg + h + dd + markHolesOneD, yg + markShift + w + dd + markHolesOneD]);//D文字标注  
                  var markers = [myBfgGapGMakerW, myBfgGapGMakerH, myBfgGapGMakerY, myBfgGapGMakerD]
            } else if (area == "F") {
                  var myBfgGapFMakerW = {
                        paths: {
                              "WFLine0": new makerjs.paths.Line([xf - markShift, yf + w / 2], [xf - markShift, yf - w / 2]),
                        }
                  };
                  var myBfgGapFMakerH = {
                        paths: {
                              "HFLine0": new makerjs.paths.Line([xf - h, yf + w / 2], [xf - h, yf + markShiftFour + w / 2]),
                              "HFLine2": new makerjs.paths.Line([xf - h, yf + markShift + w / 2], [xf, yf + markShift + w / 2]),
                        }
                  };
                  var myBfgGapFMakerY = {
                        paths: {
                              // "YHLine0": new makerjs.paths.Line([xh-x0, yh - markShiftTwo], [xh, yh - markShiftTwo]),
                              // "YHLine1": new makerjs.paths.Line([xh-x0, yh], [xh-x0, yh-markShiftFour]),
                              // "YHLine2": new makerjs.paths.Line([xh, yh], [xh, yh-markShiftFour]),
                        }
                  };
                  var myBfgGapFMakerD = {
                        paths: {
                              "DFLine0": new makerjs.paths.Line([xf - h, yf - w / 2], [xf - h - dd - markHolesOneD, yf - w / 2 - dd - markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapFMakerW, TxtW, [xf - markShiftThree, yf - w / 2], [xf - markShiftThree, yf + w / 2]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapFMakerH, TxtH, [xf - h, yf + markShiftThree + w / 2], [xf, yf + markShiftThree + w / 2]);//H文字标注
                  makerjs.model.addCaption(myBfgGapFMakerY, TxtY, [xf - y0, yf - markShiftFour], [xf, yf - markShiftFour]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapFMakerD, TxtD, [xf - h - markShiftTwo - dd - markHolesOneD, yf - w / 2 - dd - markHolesOneD], [xf - h - markShiftTwo, yf - w / 2]);//D文字标注  
                  var markers = [myBfgGapFMakerW, myBfgGapFMakerH, myBfgGapFMakerY, myBfgGapFMakerD]
            } else if (area == "I") {
                  var myBfgGapIMakerW = {
                        paths: {
                              "WILine0": new makerjs.paths.Line([xi - markShift, yi], [xi - markShift, yi + w]),
                        }
                  };
                  var myBfgGapIMakerH = {
                        paths: {
                              "HILine0": new makerjs.paths.Line([xi - h, yi], [xi - h, yi - markShiftFour]),
                              "HILine2": new makerjs.paths.Line([xi - h, yi - markShift], [xi, yi - markShift]),
                        }
                  };
                  var myBfgGapIMakerY = {
                        paths: {
                              "YILine0": new makerjs.paths.Line([xi, yi - y0], [xi + markShiftFour, yi - y0]),
                              "YILine1": new makerjs.paths.Line([xi + markShift, yi - y0], [xi + markShift, yi]),
                              "YILine2": new makerjs.paths.Line([xi, yi], [xi + markShiftFour, yi]),
                        }
                  };
                  var myBfgGapIMakerD = {
                        paths: {
                              "DILine0": new makerjs.paths.Line([xi - h, yi + w], [xi - h - dd - markHolesOneD, yi + w - dd - markHolesOneD]),
                        }
                  };
                  makerjs.model.addCaption(myBfgGapIMakerW, TxtW, [xi - markShiftThree, yi], [xi - markShiftThree, yi + w]);//W文字标注 
                  makerjs.model.addCaption(myBfgGapIMakerH, TxtH, [xi - h, yi - markShiftThree], [xi, yi - markShiftThree]);//H文字标注
                  makerjs.model.addCaption(myBfgGapIMakerY, TxtY, [xi + markShiftThree, yi - y0], [xi + markShiftThree, yi]);//R1文字标注
                  makerjs.model.addCaption(myBfgGapIMakerD, TxtD, [xi - markShift - h - dd - markHolesOneD, yi + w - dd - markHolesOneD], [xi - h - markShift, yi + w]);//D文字标注  
                  var markers = [myBfgGapIMakerW, myBfgGapIMakerH, myBfgGapIMakerY, myBfgGapIMakerD]
            }
      }
      console.log("markers||||||||||||||||||=", markers)
      return markers;
};
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function ButterflyGap(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut, cutLine, cutFilletRadius) {

      var frame = outParam.shapeName;
      console.log("outParam==", outParam)
      console.log("model==", model)
      console.log("inputParam==", inputParam)
      console.log("outParam.shapeName==////////", outParam.shapeName)
      if (typeof (frame) == "undefined") {
            var R = inputParam.R, R1 = inputParam.R1, W = inputParam.W, H = inputParam.H, X = inputParam.X, Y = inputParam.Y, area = inputParam.area,
                  myZoom = zoom * 1, myθCut = θCut, myrCut = rCut, cutLine = cutLine * 1, cutFilletRadius = cutFilletRadius * 1,
                  plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = "Rectangle",
                  glassW = outParam.glassW, glassH = outParam.glassH,
                  markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
                  markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,

                  h = H * 1 * myZoom,
                  w = W * 1 * myZoom,
                  d = R * 2 * myZoom,
                  r = R * 1 * myZoom,
                  // r1 = R1 * 1 * myZoom,
                  dd = (d / 2) / Math.sqrt(2),
                  x0 = X * 1 * myZoom,
                  y0 = Y * 1 * myZoom;
            if (plate.models === undefined || plate.models === "") {
                  console.log("1111111111111111");
                  plate.models = {};
            }
            if (cutPlate.models === undefined || cutPlate.models === "") {
                  cutPlate.models = {};
            }
            if (markers.models === undefined || markers.models === "") {
                  markers.models = {};
            }
            if (d !== 0) {
                  var TxtD = "R" + R;
            }
            if (h !== 0) {
                  var TxtH = H;
            }
            if (w !== 0) {
                  var TxtW = W;
            }
            if (x0 !== 0) {
                  var TxtX = X;
            }
            if (y0 !== 0) {
                  var TxtY = Y;
            }
      } else {
            var R = inputParam.R, R1 = inputParam.R1, W = inputParam.W, H = inputParam.H, X = inputParam.X, Y = inputParam.Y, area = inputParam.area, myZoom = zoom * 1, myθCut = θCut, myrCut = rCut,
                  plate = model.plate, cutPlate = model.cutPlate, markers = model.markers, frame = outParam.shapeName,
                  glassW = outParam.glassW, glassH = outParam.glassH, cutLine = cutLine * 1, cutFilletRadius = cutFilletRadius * 1,
                  markShift = fixedParam.markShift, markShiftTwo = fixedParam.markShiftTwo,
                  markShiftThree = fixedParam.markShiftThree, markShiftFour = fixedParam.markShiftFour, markHolesOneD = fixedParam.markHolesOneD,

                  h = H * 1 * myZoom,
                  w = W * 1 * myZoom,
                  d = R * 2 * myZoom,
                  // r1 = R1 * 1 * myZoom,
                  r = d / 2,
                  dd = (d / 2) / Math.sqrt(2),
                  x0 = X * 1 * myZoom,
                  y0 = Y * 1 * myZoom;
            if (plate.models === undefined || plate.models === "") {
                  plate.models = {};
            }
            if (cutPlate.models === undefined || cutPlate.models === "") {
                  cutPlate.models = {};
            }
            if (markers.models === undefined || markers.models === "") {
                  markers.models = {};
            }
            /*
            h = H*1,
               w= W*1,
               d= R*2,
               r=d/2,
               dd=(d/2)/Math.sqrt(2),
                 x0 = X*1,
                 y0 = Y*1;
                 */
            if (d !== 0) {
                  var TxtD = "R" + R;
            }
            if (h !== 0) {
                  var TxtH = H;
            }
            if (w !== 0) {
                  var TxtW = W;
            }
            if (x0 !== 0) {
                  var TxtX = X;
            }
            if (y0 !== 0) {
                  var TxtY = Y;
            }
      }
      if (frame == "Rectangle") {
            console.log("frame==undefined||||*****")
            //在A区域 计算孔的位置       
            var xa = x0, ya = glassH * 1 - y0,
                  //B区域//只有Y标注没有X标注 
                  xb = glassW * 1 / 2, yb = glassH * 1 - y0,
                  //C区域
                  xc = glassW * 1 - x0, yc = glassH * 1 - y0,
                  //在G区域 计算孔的位置
                  //D区域
                  //只有X标注没有Y标注 
                  xd = x0, yd = glassH * 1 / 2,
                  //E区域
                  //只有X标注没有Y标注 
                  xe = glassW * 1 / 2, ye = glassH * 1 / 2,
                  //F区域
                  //只有X标注没有Y标注 
                  xf = glassW * 1 - x0, yf = glassH * 1 / 2,
                  xg = x0, yg = y0,
                  //在H区域 计算孔的位置
                  //只标注Y
                  xh = glassW * 1 / 2, yh = y0,
                  //在I区域 计算孔的位置
                  xi = glassW * 1 - x0, yi = y0;
            var OffsetParam = {};
      } else if (frame == "IsoscelesTrapezoid") {

      } else if (frame == "RightAngledTrapezoid") {

      } else if (frame == "OtherTrapezoidsA") {

      } else if (frame == "OtherTrapezoidsB") {

      } else if (frame == "ParallelogramA") {


      } else if (frame == "ParallelogramB") {

      }
      // 坐标参数
      var paramCoordinate = { x0, r, cutLine, cutFilletRadius, h, w, xa, ya, xb, yb, xd, yd, xf, yf, xc, yc, xg, yg, xh, yh, xi, yi, glassW, glassH };
      const allKeys = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(model.plate.models)));
      var areaPoint = "";
      console.log("//角7、地弹簧3 ------", allKeys)
      console.log("//角7、地弹簧3 ------area==", area)
      if (allKeys[0] == frame) {
            allKeys.shift();//去掉数组第一个元素
      }
      console.log("//角7、地弹簧3 位置去掉数组第一个元素------", allKeys)
      switch (area) {
            case "1": areaPoint = "A"; break;
            case "2": areaPoint = "B"; break;
            case "3": areaPoint = "C"; break;
            case "4": areaPoint = "D"; break;
            case "6": areaPoint = "F"; break;
            case "7": areaPoint = "G"; break;
            case "8": areaPoint = "H"; break;
            case "9": areaPoint = "I"; break;
      }
      /**
      * 画图
      * 
      */

      console.log("//角7、地弹簧3 ------areaPoint==", areaPoint)
      var ObjName = "myButterflyGap" + areaPoint;
      var ObjNameMmyButterflyGap = "myButterflyGap" + areaPoint + "Mark";//角标记
      var ObjNameMmyButterflyGap = "myButterflyGap" + areaPoint + "Mark";//角标记
      ObjName = creatmyButterflyGap(areaPoint, paramCoordinate);//图形
      console.log("ObjName===|||||||||", ObjName);
      ObjNameMmyButterflyGap = creatmyButterflyGapMark(outParam, areaPoint, paramCoordinate, inputParam, fixedParam, OffsetParam, zoom);//图形
      console.log("ObjNameMmyButterflyGap===|||||||||角标注", ObjNameMmyButterflyGap);
      console.log("cutPlate.models====************", cutPlate.models),
            console.log("plate.models====**************", plate.models),
            console.log("markers.models====*************", markers.models),
            cutPlate.models["TypeGapes_myButterflyGap" + areaPoint + myHolesNum] = ObjName[1];
      plate.models["TypeGapes_myButterflyGap" + areaPoint + myHolesNum] = ObjName[1];
      markers.models["TypeGapes_myButterflyGap" + areaPoint + myHolesNum] = ObjName[1];
      markers.models["TypeGapes_myButterflyGapW" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyButterflyGap[0];
      markers.models["TypeGapes_myButterflyGapH" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyButterflyGap[1];
      markers.models["TypeGapes_myButterflyGapX" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyButterflyGap[2];
      markers.models["TypeGapes_myButterflyGapD" + areaPoint + myHolesNum + "Mark"] = ObjNameMmyButterflyGap[3];
      myHolesNum++;
      return { plate, cutPlate, markers, myHolesNum }
};


export default ButterflyGap;